import { Button, Col, Modal } from "react-bootstrap";
import { infNFesInterface } from "../../../../interfaces";
import { JRow } from "../../../../components/Components";
import NFesUnidadeTranspInfLacreCargaLacresUnidTransp from "./NFesUnidadeTranspInfLacreCargaLacresUnidTransp";
import NFesUnidadeTranspInfLacreCargaInfUnidadeCarga from "./NFesUnidadeTranspInfLacreCargaInfUnidadeCarga";

interface formProps {
    notaFiscal: infNFesInterface;
    setNotaFiscal: React.Dispatch<React.SetStateAction<infNFesInterface>>
    id: number | string;
    show: boolean;
    handleClose: () => void;
}

const NFesUnidadeTranspInfLacreCarga: React.FC<formProps> = ({ notaFiscal, setNotaFiscal, show, handleClose, id }) =>{
   
    return (<>
        <Modal show={show} onHide={handleClose} centered backdrop='static' size="xl" fullscreen={'xl-down'} scrollable>
            <Modal.Header closeButton>
                <Modal.Title>Lacres e Unidade das Cargas - #{
                    notaFiscal?.infUnidTransp?.filter(item => 
                        item.id.toString() === id.toString())[0]?.idunidtransp
                    }</Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                <JRow>
                    <Col md>
                        <div className="nav nav-underline" id="v-pills-tab-lacres-carga" role="tablist">
                            
                            <button className="nav-link active" id="tablacres-tab" data-bs-toggle="pill" 
                                data-bs-target="#tablacres" type="button" role="tab"
                                >Lacres das Unidades de Transporte (Opcional)</button>
                                
                            <button className="nav-link" id="tabcarga-tab" data-bs-toggle="pill" 
                                data-bs-target="#tabcarga"
                                type="button" role="tab">Inf. das Unidades de Carga (Opcional)</button>

                        </div>
                        <div className="tab-content pt-2 px-2" id="v-pills-tabContentlacres">
                            <div className="tab-pane fade show active" id="tablacres" role="tabpanel">
                                <NFesUnidadeTranspInfLacreCargaLacresUnidTransp 
                                    notaFiscal={notaFiscal} setNotaFiscal={setNotaFiscal} id={id}/>
                            </div>
                            <div className="tab-pane fade" id="tabcarga" role="tabpanel" >
                                <NFesUnidadeTranspInfLacreCargaInfUnidadeCarga 
                                    notaFiscal={notaFiscal} setNotaFiscal={setNotaFiscal} id={id}/>
                            </div>
                        </div>
                    </Col>
                </JRow>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} >
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    </>)
}

export default NFesUnidadeTranspInfLacreCarga;